import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "../lib/api";
import { fmtDate } from "../lib/utils2";

export default function Blog() {
  const [articles, setArticles] = useState([]);
  useEffect(() => { api.get("/articles").then((r) => setArticles(r.data)); }, []);
  return (
    <div>
      <section className="bg-navy py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-white">Blog & Approfondimenti</h1>
          <p className="text-slate-300 mt-4 max-w-2xl mx-auto text-lg">Articoli di approfondimento collegati agli episodi del podcast.</p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {articles.map((a) => (
          <Link key={a.id} to={`/blog/${a.id}`} data-testid={`article-${a.id}`} className="group bg-white border border-slate-100 rounded-xl overflow-hidden hover:-translate-y-2 transition-transform duration-300 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <img src={mediaUrl(a.cover_url)} alt="" className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="p-6">
              <div className="text-xs text-slate-400 mb-2">{fmtDate(a.published_at)} • {a.author}</div>
              <h3 className="font-serif text-xl font-semibold text-navy leading-snug mb-2 group-hover:text-petrol">{a.title}</h3>
              <p className="text-sm text-slate-500 line-clamp-3">{a.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
